import CountryService from '../services/CountryService';

const { country } = CountryService.GetInstance(); 

export default [
  {
    fieldName: 'Street',
    type: 'text',
    label: 'Street'
  },
  {
    fieldName: 'StreetNumber',
    type: 'text',
    label: 'No.'
  },
  {
    fieldName: 'City',
    type: 'text',
    label: 'City'
  },
  {
    fieldName: 'Zip',
    type: 'text',
    label: 'Zip'
  },
  {
    fieldName: 'Country',
    type: 'select',
    label: 'State',

    options: country ? [
      {
        label: country.name,
        value: country.code
      }
    ] : [],
  }
];



// WEBPACK FOOTER //
// ./src/formFields/address.tsx